/**
 * Job period filter.
 */
export type JobPeriodFilterOption = (typeof allJobPeriodFilterOptions)[number]

/**
 * All job period filter options.
 *
 * Saved list settings refer to options by position, so only ever append.
 */
export const allJobPeriodFilterOptions = ['All', 'Current', 'Old'] as const
